import {Injectable, signal} from '@angular/core';
import {MessageService, ToastMessageOptions} from 'primeng/api';

export const PROGRESS_TOAST_KEY = 'progress';

@Injectable()
export class MercatusToastyService {
    private readonly life = 5000;
    private progressToastCounter = 0;
    private openProgressToasts = new Set<string>();

    // Detail texts of the open progress toasts, rendered by the progress <p-toast> in app.component.html
    public readonly progressToastDetails = signal<Record<string, string>>({});

    constructor(private messageService: MessageService) {
    }


    public showSuccessToast(message: string) {
        this.messageService.add({severity: 'success', summary: 'Erfolg', detail: message, life: this.life});
    };

    public showWarningToast(message: string) {
        this.messageService.add({severity: 'warn', summary: 'Warnung', detail: message, life: this.life});
    };


    public showErrorToast(message: string) {
        this.messageService.add({severity: 'error', summary: 'Fehler', detail: message, life: this.life});
    };


    // Sticky info toast whose text can be updated until it is cleared
    public showProgressToast(message: string): string {
        const id = `progress-${++this.progressToastCounter}`;
        this.progressToastDetails.update(details => ({...details, [id]: message}));
        this.openProgressToasts.add(id);
        this.messageService.add(this.progressToastMessage(id));
        return id;
    }

    public updateProgressToast(id: string, message: string) {
        this.progressToastDetails.update(details => ({...details, [id]: message}));
    }

    // The detail text is kept so the toast does not lose its text while it fades out
    public clearProgressToast(id: string) {
        this.openProgressToasts.delete(id);
        this.messageService.clear(PROGRESS_TOAST_KEY);
        this.openProgressToasts.forEach(openId => this.messageService.add(this.progressToastMessage(openId)));
    }

    private progressToastMessage(id: string): ToastMessageOptions {
        return {key: PROGRESS_TOAST_KEY, severity: 'info', summary: 'Info', sticky: true, data: id};
    }
}
